var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OzIconButton,{attrs:{"dark-mode":_vm.darkMode,"label":_vm.label,"href":_vm.href,"icon-size":_vm.iconSize,"color-scheme":_vm.colorScheme,"icon-name":"chevron_left_center"},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }